import { render } from "./TooltipIcon.vue?vue&type=template&id=1962892c&scoped=true"
import script from "./TooltipIcon.vue?vue&type=script&lang=js"
export * from "./TooltipIcon.vue?vue&type=script&lang=js"

import "./TooltipIcon.vue?vue&type=style&index=0&id=1962892c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1962892c"]])

export default __exports__